import { createI18nText } from "@hilma/netina2all";

const advertisementText = createI18nText({
	he: {
		title: 'ניהול פרסום',
		addCampaign: 'הוספת קמפיין',
		tableTitles: {
			name: 'שם הקמפיין',
			campaignDate: 'תאריך',
			enteries: 'מספר כניסות',
			kitCount: 'מספר מוצרים',
			donation: 'תרומה משוערת מרכישה',
			atonement: 'תרומה משוערת ממתנות לאביונים',
			link: 'קישור'
		},
		noResults: 'לא נמצאו קמפיינים',
		campaignDate: 'תאריך פרסום',
		source: 'מקור- באנגלית לקישור, ללא רווחים',
		medium: 'מדיום- באנגלית ללא רווחים',
		content: 'תוכן- באגלית ללא רווחים',
		sucksess: 'הקמפיין נוסף בהצלחה'
	},
	en: {
		title: 'Advertising Management',
		addCampaign: 'Add Campaign',
		tableTitles: {
			name: 'Campaign Name',
			campaignDate: 'Date',
			enteries: 'Enteries',
			kitCount: 'Products Sold',
			donation: 'Estimated Purchase Donations',
			atonement: "Estimated Matanot L'evyonim Donations",
			link: 'Link'
		},
		noResults: 'No campaigns found',
		campaignDate: 'Campaign date',
		source: 'Source (no spaces)',
		medium: 'Medium (no spaces)',
		content: 'Content (no spaces)',
		sucksess: 'The campaign has been added successfully'
	}
});

export default advertisementText;